import styled from "styled-components";

export * from "@neru/base/styles";

export const Logo = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  margin: 8px 0;

  div {
    border-radius: 2px;
    position: absolute;
  }

  div:nth-child(1) {
    background: #facc4b;
    height: 8.5px;
    left: 0;
    top: 2px;
    transform: rotate(45deg);
    width: 8.5px;
  }

  div:nth-child(2) {
    background: #fb8fd8;
    height: 8px;
    left: 12px;
    top: 3px;
    transform: rotate(16deg);
    width: 8px;
  }

  div:nth-child(3) {
    background: #9941ff;
    bottom: 0;
    height: 11px;
    left: 0;
    width: 11px;
  }

  div:nth-child(4) {
    background: #fa7454;
    bottom: 1px;
    height: 9px;
    left: 13px;
    transform: rotate(30deg);
    width: 9px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
